<template lang="pug">
    v-app(light)
        div.wrapper
            div.content
                // Logo
                logo-component.mb-3.unsubscribeLogo(type="auth")

                // Message
                div.bodyMessage.mb-2 {{ $t('unsubscribe.title') }}
                div.bodyMessage {{ $t('unsubscribe.body') }}
</template>

<script>
    import VueTypes from 'vue-types';
    import unsubscribe from '~api/unsubscribe';
    import Title from '~components/Title';
    import Logo from '~components/Logo';

    export default {
        components: {
            LogoComponent: Logo,
            TitleComponent: Title
        },
        props: {
            id: VueTypes.string.def('')
        },
        created() {
            unsubscribe.unsubsribeFromEmails(this.id);
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl"
    .wrapper
        min-height: 100%
        min-height: 100vh
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        background-color: $theme.primary
        background-image: url('./images/2-min.png')
        background-size: cover

    .content
        max-width: 600px
        padding: 30px 15px
        margin: 10px
        background-color: rgba($theme.primary, 0.85)
        border-radius: 10px

    .unsubscribeLogo
        width: 160px
</style>
